// extracted by mini-css-extract-plugin
export default {"footer":"uCS_GLB6cZOw8NdGM8YZ"};